<template>
    <div id="user">
        <Topbar v-if="this.$store.state.topbar_actions_visible" @action="fnAction"></Topbar>
        <v-container class="main left">
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs12 sm6 md3 class="logo" >
                    <img :src="( user.avatar )? user.avatar : '/img/avatar.svg'" />
                </v-flex>
                <v-flex xs12 sm6 md9 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "basic_info" ) }}</v-flex>
                            <v-flex xs12 md6>
                                <div class="label">{{ $t( "params.name" ) }}:</div><div class="value">{{ user.name | checkParam }}</div>
                                <div class="label">{{ $t( "params.username" ) }}:</div><div class="value">{{ user.username | checkParam }}</div>
                            </v-flex>
                            <v-flex xs12 md6>
                                <div class="label"><Email :email="$t( 'params.email' ) + ':'"></Email></div><div class="value">{{ user.email | checkParam }}</div>
                                <div class="label">{{ $t( "params.type" ) }}:</div><div class="value">{{ user.type | formatType }}</div>
                                <div class="label">{{ $t( "params.status" ) }}:</div><div class="value">{{ formatUserMicStatus( user.status ) }}</div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <LastUpdate :data="user.user_modify"></LastUpdate>
                            
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
            <!-- <v-layout row wrap class="section-container" id="notes">
                <NoteList :notes="user.notes" :page="'user'" :id="id" @create_note="createNote"></NoteList>
            </v-layout> -->
        </v-container>
        <ContactRelationsList :contacts_rel="user.current_roles" class="contact right"></ContactRelationsList>
    </div>
</template>

<script>

import i18n from '@/i18n'
import { formatBackofficeGestorType } from '@/constants/backofficeUserTypes.js'
import NoteList from '@/components/ui/NoteList'
import TeamCard from '@/components/ui/cards/mini/Team'
import Topbar from '@/components/ui/Topbar'

import ContactRelationsList from '@/components/ui/ContactRelationsList'

import Phone from '@/components/ui/labels/Phone'
import Email from '@/components/ui/labels/Email'
import Country from '@/components/ui/labels/Country'
import LastUpdate from '@/components/ui/LastUpdate'

export default {
  name: 'CardUser',
  components: { NoteList, TeamCard, Topbar, Phone, Email, Country, ContactRelationsList, LastUpdate },
  props: { },
  data () {
    return {
      id: this.$route.params.id,
      current_roles: []
    }
  },
  computed: {

      user() {
            var oUser = {...this.$store.getters[ 'user/get_by_id' ]( this.$route.params.id )};
            if( !oUser ) oUser = {};

            oUser.gender = ( oUser.gender != null )? 'gender.' + oUser.gender : null

            // var aEvents = [];
            // if( typeof oClub.teams !== 'undefined' ){
            //     for( var key in oClub.teams ){
            //         var team = oClub.teams[ key ];
            //         if( typeof aEvents[ team.event.id ] === 'undefined' ){
            //             team.event.name = this.formatEventName( team.event.name, team.event.edition );
            //             aEvents[ team.event.id ] = team.event;
            //             aEvents[ team.event.id ].teams = [];
            //         }
            //         aEvents[ team.event.id ].teams.push( {
            //             name: ( team.name == null )? oClub.name : team.name,
            //             category: team.category,
            //             status: team.status
            //         });
            //     }
            // }
            // oClub.events = ObjectToArray( aEvents );

            oUser.notes = ObjectToArray( oUser.notes );
            oUser.notes.sort( function( n1, n2 ){
              if( moment( n1.last_update ).valueOf() < moment( n2.last_update ).valueOf() ) return 1
              return -1
            })
            
            if( typeof oUser.current_roles === 'undefined' ) oUser.current_roles = []
            else{
                oUser.current_roles.forEach( role => {
                    role.visible = true
                })
            }

            this.current_roles = oUser.current_roles
            
            // this.user = ouser

            return oUser
      }

    //   contacts_rel() {       
    //       if( typeof this.user.current_roles === 'undefined' ) return [];
    //       console.log( this.user.current_roles );
    //       return [...this.user.current_roles];
          
    //   }

    //   contacts() {
    //       return [ { name: 'Manolito García', tel: '2432343248', 'role': 'Responsable', 'email': 'sadsads@sadsd.com' }, { name: 'Mario Martinez', tel: '2432343248', 'role': 'Responsable', 'email': 'sadsads@sadsd.com' } ];
    //   }
  },
  created(){
        this.$overlay.loading()

        this.$store.commit( 'setTopbarActionsVisible', true );
        this.$store.commit( 'setMenuVisible', true );
                    
        var id = this.$route.params.id;
        var self = this
        this.$store.dispatch( 'user/load_by_id', { id: id } ).then( function(){
            self.$overlay.hide()
            // var ouser = {...self.$store.getters[ 'users/get_by_id' ]( self.$route.params.id )};
            // if( !ouser ) ouser = {};

            // // var aEvents = [];
            // // if( typeof oClub.teams !== 'undefined' ){
            // //     for( var key in oClub.teams ){
            // //         var team = oClub.teams[ key ];
            // //         if( typeof aEvents[ team.event.id ] === 'undefined' ){
            // //             team.event.name = this.formatEventName( team.event.name, team.event.edition );
            // //             aEvents[ team.event.id ] = team.event;
            // //             aEvents[ team.event.id ].teams = [];
            // //         }
            // //         aEvents[ team.event.id ].teams.push( {
            // //             name: ( team.name == null )? oClub.name : team.name,
            // //             category: team.category,
            // //             status: team.status
            // //         });
            // //     }
            // // }
            // // oClub.events = ObjectToArray( aEvents );

            // ouser.notes = ObjectToArray( ouser.notes );
            
            // if( typeof ouser.current_roles === 'undefined' ) ouser.current_roles = []
            // else{
            //     ouser.current_roles.forEach( role => {
            //         role.visible = true
            //     })
            // }
            
            // self.user = ouser
            // console.log( self.user )
        });
  },
  methods: {
        createNote(){
            this.$card.note( { current_page: 'user', current_id: this.$route.params.id } );
        },

        createContactRelationship(){
            this.$card.contactrel( { current_page: 'user', current_id: this.$route.params.id } );
        },

        getCountry( id ){
            if( id ){
                return {...this.$store.getters.getCountryByID( id ) };
            }
            return false;
        },

        fnAction( emit ){
            if( typeof emit.action === 'undefined' || emit.action == null ) return
            switch( emit.action ){
                case 'remove':              this.fnRemove( emit.params )
                                            break
                case 'activate_user':       this.fnSetGestorStatus( 1 )
                                            break
                case 'deactivate_user':     this.fnSetGestorStatus( -2 )
                                            break
                case 'create_note':         this.createNote( emit.params )
                                            break
                case 'create_relationship': this.createContactRelationship( emit.params )
                                            break
                case 'rel_club_event':      this.fnRelClubEvent( emit.params )
                                            break
                case 'destroy':             this.fnDestroy( emit.params )
                                            break
            }
        },

        fnSetGestorStatus( status ){
            var self = this;
            var u = this.user;
            if( parseInt( u.status, 10 ) === status ){
                return;
            }
            this.$overlay.loading();
            this.$store.dispatch( 'user/setStatus', { id: this.id, status: status } ).then( function( response ){
                self.$overlay.hide();
                if( response && response.status ){
                    self.$store.dispatch( 'user/load_by_id', { id: self.id } );
                }
            });
        },

        fnRemove() {
            var self = this;
            this.$popup.confirm({
                message: i18n.t( 'users.remove_message' ),
                btnSuccess: i18n.t( 'accept' ),
                btnError: i18n.t( 'cancel' )
            }, function(){
                self.$overlay.loading();
                self.$store.dispatch( 'user/remove', self.id ).then( function( response ){
                    self.$overlay.hide();
                    if( response && response.status ){
                        self.$router.push( { name: 'home' } );
                    }
                });
            });
        },

        getPosition( position ){
            var pos = this.$store.getters[ 'persons/getPosition']( position )
            if( pos && typeof pos.name !== 'undefined' ){
                return pos.name
            }

            return null
        },

        editRole( key ){
            var event = ( this.$store.getters.isEventSelected )? this.$store.getters[ 'events/getCurrentEvent' ]() : false;
                event = ( event )? this.$root.formatEventUrl( event.name, event.edition ).replace( '/event/', '' ) : null
            var page = ( event )? 'event_' : ''
                page = page + 'users_role_edit'
            var role = this.user.current_roles[ key ]

            var type = ""
            switch( parseInt( role.contact_type_id ) ){
                case 107:   type = 'player'
                            break
                case 5:
                case 108:
                case 6:     type = 'manager'
                            break
                case 1:     
                case 2:     type = 'staff'

                case 111:   type = 'team'
                            break
            }
            
            this.$router.push( { name: page, params: { event: event, id: this.user.id, role_id: role.id, type: type } } )
        },

        fnDestroy(){
            this.$destroy()
        },

        formatUserMicStatus (value) {
            const s = parseInt(value, 10);
            if (s === 1) {
                return this.$t("user.status_mic_active");
            }
            if (s === -2) {
                return this.$t("user.status_mic_inactive");
            }
            if (s === -1) {
                return this.$t("user.status_mic_deleted");
            }
            if (value === undefined || value === null || value === "") {
                return "";
            }
            return String(value);
        }
  },
    filters: {
        formatType( value ){
            const gestorLabel = formatBackofficeGestorType( value );
            if ( gestorLabel ) {
                return gestorLabel;
            }
            switch (value) {
                case null:
                    return "";
                    break;
                case 1:
                    return "Administrador Backoffice";
                    break;
                case 4:
                    return "Usuari MicCamps";
                    break;
                case 10:
                    return "Administrador club ZonaEquipos";
                    break;
                case 11:
                    return "Usuari team ZonaEquipos";
                    break;
                case 20:
                    return "Player Campus";
                    break;
            }
            return "";
        }
    }
}
</script>

<style lang="scss" scoped>
    #user {
        width: 100%;
        display: inline-block;

        .container {
            width: calc( 100% - 350px);
            padding: 0px;
            max-width: 100%;

            &.main {
                overflow-y: auto;
                height: calc( 100vh - 110px );
            }

            .section-container {
                padding: 20px;
                
                &#basic {
                    background-color: #fff;
                    @include  box-shadow( $h: 0px , $v: 3px , $b: 8px , $s: 0px , $c: #00000011 );
                }
                &#notes {
                    background-color: $complem-color-light; 
                }
                &#teams {
                    background-color: #fff;
                    @include  box-shadow( $h: 0px , $v: -3px , $b: 8px , $s: 0px , $c: #00000011 );
                }
            }
        }

        .contact {
            width: 20%;
            width: 350px;
            padding: 20px;
        }
    
        .logo {
            width: 150px;
            height: 150px;
            border-radius: 50%;

            img {
                object-fit: contain;
                object-position: center;
                height: 100%;
                width: auto;
                margin: 0 auto;
                display: block;
                margin-top: 10px;
                opacity: 0.5;
            }
        }
        .info {

            .container {
                margin: 0;
                padding: 0 20px;
                padding-left: 40px;
                width: 100%;

                .section {
                    margin-bottom: 25px;

                    .name {
                        font-weight: lighter;
                        font-size: 24px;
                        @include font-size(14px);
                        border-bottom: 1px solid #ddd;
                        margin: 10px 0 20px 0;
                        color: $main-color;
                        text-transform: uppercase;
                        margin-bottom: 20px;
                        border-bottom: 2px solid $complem-color-dark;
                        color: $complem-color-dark;
                    }

                    .label {
                        font-family: $text-light;
                        @include font-size(14px);
                        width: 40%;
                        float: left;
                        line-height: 20px;
                    }

                    .value {
                        font-family: $text;
                        font-weight: lighter;
                        @include font-size(14px);
                        width: 60%;
                        float: left;
                        margin-bottom: 10px;
                    }

                    .edit {
                        background-image: url(/img/edit-b.svg);
                        background-size: 15px;
                        background-repeat: no-repeat;
                        background-position: left center;
                        position: absolute;
                        right: 0;
                        top: -5px;
                        padding-left: 20px;
                        text-transform: none;
                        font-weight: bold;
                    }
                }
            }

            &.role .name {
                position: relative;
                width: fit-content;
                cursor: pointer;

                &::after {
                    content: "";
                    width: 30px;
                    height: 15px;
                    background: url(/img/down.svg);
                    background-repeat: no-repeat;
                    background-size: 15px;
                    background-position: center right;
                    position: absolute;
                }
            }
        }
    }
</style>
